/* ============================================================================
   madeatdawn-submenu.js  —  Custom submenu, mobile drawer behavior
   ----------------------------------------------------------------------------
   The theme's drawer script (global.js MenuDrawer) opens a submenu: the
   <summary> toggles [open] on <details class="menu-drawer__dropdown-details">
   and it adds .menu-opening a tick later. Its back button (any <button> in the
   drawer) removes .menu-opening and removes [open] after a 400ms animation.
   The panel's position is keyed on .menu-opening (madeatdawn-mobile-menu.css),
   so it slides in AND out. This script adds what the theme doesn't do:
     1. aria-expanded on the row's <summary> tracks the panel, and opening a
        panel moves focus to its back button (the theme tries before the panel
        is rendered, so focus stayed on the row underneath).
     2. Opening one submenu closes any other open one, so panels never stack.
   Pure event delegation on document — works for markup added after load.
   ============================================================================ */
(function () {
  var SUBMENU = 'details.menu-drawer__dropdown-details';

  function setExpanded(details, open) {
    var summary = details && details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // "toggle" does not bubble, so listen in the capture phase.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches(SUBMENU)) return;
    setExpanded(details, details.open);
    if (details.open) {
      // The panel is still visibility:hidden when "toggle" fires (its
      // visibility transitions in), and focus() on it would silently fail.
      var back = details.querySelector('.menu-drawer__close-button');
      if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, 60);
    }
  }, true);

  document.addEventListener('click', function (event) {
    // Back button: the theme closes the panel (with its slide-out); only the
    // row's state is updated here, straight away rather than after 400ms.
    var back = event.target.closest('.menu-drawer__close-button');
    if (back) {
      setExpanded(back.closest(SUBMENU), false);
      return;
    }

    // Opening a submenu: collapse any other open submenu first.
    var toggle = event.target.closest('.menu-drawer__dropdown-toggle');
    if (toggle) {
      var current = toggle.closest(SUBMENU);
      document.querySelectorAll(SUBMENU + '[open]').forEach(function (details) {
        if (details === current) return;
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
        setExpanded(details, false);
      });
    }
  });
})();
